import { useQuery } from '@tanstack/react-query'

import Api from '@/shared/services/api'
import { textSort } from '@/ui/utils/sorts'

export function getUserGroupListQueryKey(groupId: string) {
  return ['groupUser', groupId]
}

export function useUserGroupListQuery(
  groupId: string,
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: getUserGroupListQueryKey(groupId),
    queryFn: async () => {
      const [response, error] = await Api.listGroupUsersByFeedGroup(groupId)

      if (error) throw error

      return response.data.toSorted(({ name: a }, { name: b }) =>
        textSort(a, b)
      )
    },
    enabled: !!groupId && enabled,
    initialData: []
  })
}
